<section class="has-padding-block-1 animated fadeIn">
  <div class="row">
    <div class="col-md-6 col-sm-7">
      <h2 class="section-title">Who We Are</h2>
      <h5 class="mt-3 mb-4">Philly Foodworks is an online market and farm share program that is dedicated to creating a
        sustainable local food system for the Greater Philadelphia region.</h5>
      <p>Having started out as urban farmers
        ourselves, we understand the rewards and challenges of growing food, and we are committed to building
        a better distribution network between farmers/producers and consumers in our area.</p>
    </div>
    <div class="col-md-6 col-sm-5">
      <div class="about-img" style="background-image: url('assets/images/landing/about-us/who-we-are.webp')"
        title="PFW - Who We Are">
        <!--        <img src="assets/images/logo-white.svg?v={{logoVersionNumber()}}" class="about-img__logo" alt="PFW Membership">-->
      </div>
    </div>
  </div>
  <div class="spacer-4"></div>
  <div class="banner-title-wrap is-right">
    <div class="banner-title is-multi-line is-primary">
      <p>We make high-quality, sustainably produced food available to consumers year-round</p>
    </div>
  </div>
  <div class="spacer-4"></div>
  <div>
    <h2 class="section-title">About Our Online Market</h2>
    <div class="ul-icon-list">
      <span class="list-icon material-symbols-outlined">shopping_bag</span>
      <div class="list-content">
        <h3 class="list-title">Shop for individual items or select one of our unique shares.</h3>
        <p>In our online market, we offer the largest selection of local food in the Greater Philadelphia
          region (including fresh produce, meats, cheeses and other dairy products, baked goods, pantry items
          and prepared foods, and home and beauty products)—plus fully customizable farm share boxes.</p>
      </div>
    </div>
    <div class="ul-icon-list">
      <span class="list-icon material-symbols-outlined">local_shipping</span>
      <div class="list-content">
        <h3 class="list-title">92% of the produce we source is within a 150-mile radius of Philadelphia</h3>
        <p>Many of our local farmers grow organically but are uncertified; some use Integrated Pest Management (IPM)
          growing methods, some are certified organic, and some are pursuing Certified Naturally Grown status (a less
          costly alternative to USDA Organic). During the winter, when local produce is limited, we source non-local
          fruit. This enables us to capture the attention of some customers who would otherwise not shop during the
          winter and consequently sell more local produce. Some of our non-local produce come directly from small farms
          in the Miami area. The rest comes from a local, family-owned distributor. Unfortunately, due to our low
          non-local order volumes, we have trouble working with distributors of organic and fair trade produce. We have
          chosen to focus our efforts on building the local supply chain rather than purchasing more non-local produce
          to meet the order minimums required by larger wholesales. We never introduce non-local items that will compete
          with products from our local farmers.</p>
      </div>
    </div>
  </div>
  <hr class="is-thick">
  <div class="text-center container-lg">
    <h2 class="section-title">Our Company Mission</h2>
    <p class="h6-semibold">To help create a sustainable food system for the greater Philadelphia region, where farmers
      and food
      producers have steady income, customers have access to the fresh local foods they produce, and our
      farmland and general environment is nourished for generations to come.</p>
  </div>
  <div class="has-padding-block-2">
    <div class="container-fluid">
      <div class="flash-card-wrap has-animation fadeInUp">
        <div class="flash-card" style="background-image: url('assets/images/landing/flash-card/img-1.webp')">
          <div>
            <div class="flash-card__title">We are building a local food system</div>
            <a class="btn btn-secondary" routerLink='/pages/how-it-works/main'>How it Works</a>
          </div>
        </div>
        <div class="flash-card" style="background-image: url('assets/images/landing/flash-card/img-2.webp')">
          <div>
            <div class="flash-card__title">We are increasing access to local food</div>
            <a class="btn btn-primary" routerLink='/shop'>Our Products</a>
          </div>
        </div>
        <div class="flash-card" style="background-image: url('assets/images/landing/flash-card/img-3.webp')">
          <div>
            <div class="flash-card__title">We are moving towards zero waste</div>
            <a class="btn btn-secondary" routerLink='/pages/producers'>Our Producers</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
